export enum PopupMessageSummaries {
    Success = 'Успех!',
    Info = 'Информация',
    Warn = 'Внимание!',
    Error = 'Ошибка!'
}



// WEBPACK FOOTER //
// ./src/app/shared/dictionaries/PopupMessageSummaries.ts